<template>
  <section class="layout-section -bg-shade -no-top">
    <div class="layout-section__hgroup -bigger">
      <h2 v-scroll:reveal class="layout-section__title">Dernières publications</h2>
    </div>

    <section v-scroll:reveal class="slider" :style="{ '--height': `${sizes.height}px` }">
      <TransitionGroup :name="transitionName" tag="div" class="card-article">
        <DemoGridArticlesSingle
          v-for="publication in publications"
          :key="publication.id"
          ref="card"
          route-name="news-single"
          slug-key="newsSlug"
          :slug="publication.slug"
          :type="publication.type"
          class="slider__item"
          :style="{ '--width': `${sizes.width}px`, '--height': `${sizes.height}px` }"
        />
      </TransitionGroup>

      <div class="slider__controls">
        <button
          v-if="hasPrevPublication"
          class="slider__button -prev"
          aria-label="Afficher prochaine nouvelle"
          @click="onClickPrev"
        >
          <SvgIcon id="arrow" class="-reverse" />
        </button>

        <button
          v-if="hasNextPublication"
          class="slider__button -next"
          aria-label="Afficher prochaine nouvelle"
          @click="onClickNext"
        >
          <SvgIcon id="arrow" />
        </button>
      </div>
    </section>

    <div v-scroll:reveal class="layout-section__controls">
      <RouterLink :to="{ name: 'publication-index' }" class="button layout-section__cta">
        Voir toutes les publications
        <SvgIcon id="action-arrow" />
      </RouterLink>
    </div>
  </section>
</template>

<script>
import DemoGridArticlesSingle from '../../component-demo/partials/DemoGridArticlesSingle.vue'

export default {
  name: 'HomePublication',
  components: { DemoGridArticlesSingle },
  data() {
    return {
      startIndex: 0,
      transitionName: 'slider__item-next',
      sizes: {
        width: 0,
        height: 'auto'
      }
    }
  },
  computed: {
    itemCount() {
      const phoneCount = this.$device.phoneH ? 2 : 1
      return this.$device.laptop ? 3 : phoneCount
    },
    allPublications() {
      return this.$wp.restPublications || []
    },
    publications() {
      return this.allPublications.slice(this.startIndex, this.startIndex + this.itemCount)
    },
    hasNextPublication() {
      return this.startIndex + this.itemCount < this.allPublications.length
    },
    hasPrevPublication() {
      return this.startIndex > 0
    }
  },
  watch: {
    publications: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          if (!this.$refs.card || !this.$refs.card.length) return
          const [firstCard, secondCard] = this.$refs.card
          const card = secondCard || firstCard
          this.sizes.width = card.$el.offsetWidth
          this.sizes.height = card.$el.offsetHeight || 'auto'
        })
      }
    }
  },
  methods: {
    onClickNext() {
      if (this.hasNextPublication) {
        this.transitionName = 'slider__item-next'
        this.startIndex++
      }
    },
    onClickPrev() {
      if (this.hasPrevPublication) {
        this.transitionName = 'slider__item-prev'
        this.startIndex--
      }
    }
  }
}
</script>
